/**
 * AutoFilters class
 * @private
 */
var AutoFilters = /** @class */ (function () {
    function AutoFilters() {
    }
    return AutoFilters;
}());
export { AutoFilters };
